import { render, staticRenderFns } from "./share-space.vue?vue&type=template&id=78809b1a&scoped=true"
import script from "./share-space.vue?vue&type=script&lang=js"
export * from "./share-space.vue?vue&type=script&lang=js"
import style0 from "./share-space.vue?vue&type=style&index=0&id=78809b1a&prod&scoped=true&lang=css"
import style1 from "./share-space.vue?vue&type=style&index=1&id=78809b1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78809b1a",
  null
  
)

export default component.exports